import Vue from "vue";
import VueSignature from "vue-signature";

Vue.use(VueSignature);
